import { createRoot as mountRoot } from "react-dom/client";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/cyrillic-400.css";
import "@fontsource/manrope/latin-600.css";
import "@fontsource/manrope/cyrillic-600.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/cyrillic-700.css";
import "@fontsource/cormorant-garamond/latin-400.css";
import "@fontsource/cormorant-garamond/cyrillic-400.css";
import "@fontsource/cormorant-garamond/latin-600.css";
import "@fontsource/cormorant-garamond/cyrillic-600.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/cyrillic-400.css";
import "@fontsource/ibm-plex-mono/latin-600.css";
import "@fontsource/ibm-plex-mono/cyrillic-600.css";
import "./styles.css";
import "./city-theme.css";
import { App } from "./App";
import { stampSurface } from "./surface";
import { outboxFlush } from "./api";
import { registerServiceWorker } from "./swUpdate";
/* Eerst het oppervlak stempelen, dan pas renderen: alle layout-CSS hangt aan
   `data-surface`, en zonder deze regel tekent de browser één frame met de
   mobiele standaard. */
stampSurface();
/* De skin van deze build. In de next-build komt daarbij zijn eigen
   stylesheet als losse chunk; in productie valt deze tak bij het bouwen weg,
   dus de prod-bundel groeit er niet van. */
document.documentElement.dataset.skin =
  import.meta.env.VITE_SKIN === "next" ? "next" : "classic";
if (import.meta.env.VITE_SKIN === "next") void import("./skins/next/index.css");
mountRoot(document.getElementById("root")!).render(<App />);
void outboxFlush();

/* service worker: alleen productie. De update-afhandeling zit in swUpdate.ts;
   activeren gebeurt uitsluitend op verzoek van de gebruiker. */
if (import.meta.env.PROD) registerServiceWorker();
